import { Popover } from 'antd'
import React from 'react'
import { SketchPicker } from 'react-color'

const UserColorPicker = ({ value, onChange }) => {
  const switchStyle = {
    padding: 4,
    background: '#fff',
    borderRadius: 2,
    border: '1px solid #dedede',
    display: 'inline-block',
    cursor: 'pointer'
  }
  const colorStyle = {
    width: 36,
    height: 14,
    borderRadius: 2,
    background: value || '#727272'
  }
  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      overlayInnerStyle={{
        padding: 0
      }}
      content={<SketchPicker disableAlpha color={value || '#727272'} onChange={color => onChange?.(color.hex)} />}
    >
      <div style={switchStyle}>
        <div style={colorStyle} />
      </div>
    </Popover>
  )
}

export default UserColorPicker
